type PinTransmissionConfig = {
  securePinTransmissionEnabled: boolean;
  securePinTransmissionKey: string | null;
};

let config: PinTransmissionConfig = {
  securePinTransmissionEnabled: false,
  securePinTransmissionKey: null,
};

export const pinTransmissionConfig = {
  setFromInit(init: {
    securePinTransmissionEnabled?: boolean;
    securePinTransmissionKey?: string;
  }) {
    config = {
      securePinTransmissionEnabled: Boolean(init.securePinTransmissionEnabled),
      securePinTransmissionKey: init.securePinTransmissionKey ?? null,
    };
  },

  isEnabled(): boolean {
    return config.securePinTransmissionEnabled;
  },

  getPublicKey(): string | null {
    return config.securePinTransmissionKey;
  },
};
